import React, {useEffect, useState} from 'react'
import { get } from '../services/ApiService';
import UiInputText from "../components/Form/UiInputText";
import UiInputList from "../components/Form/UiInputList";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

interface TipoOpcao {
    id: number;
    title: string;
}

export default function TipoTarefaForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true, padrao: false, prazoDias: 0, dependencias: [] }
    });
    const { handleSubmit, reset } = methods;
    const notification = useNotification();

    // A dependência é entre tipos, então a lista é o próprio cadastro. O tipo em
    // edição sai da lista: um tipo que depende de si mesmo nunca seria liberado.
    const [tipoList, setTipoList] = useState<TipoOpcao[]>([]);

    useEffect(() => {
        get('/?route=tartipo/grid&action=list&limit=100')
            .then((resposta: any) => {
                const linhas = resposta?.data?.rows ?? [];
                const proprioId = props.data?.id;
                setTipoList(
                    linhas
                        .filter((l: any) => String(l.id) !== String(proprioId))
                        .map((l: any) => ({ id: l.id, title: l.nome }))
                );
            })
            .catch(() => {});
    }, [props.data]);

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const salvar = (dados: any) => {
        if (!dados.perfil?.id) {
            notification.error('O tipo precisa do perfil que executa a tarefa');
            return;
        }
        props.triggerSubmit(dados);
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={9} name="nome" label="Nome" placeholder="Pós Venda -> Configurar Internet"/>
                        <UiInputCheckbox size={3} name="ativo" label="Ativo"/>
                        <UiInputSuggest size={6} name="perfil" router="unperfil" idField="id" titleField="nome" label="Perfil que executa"/>
                        <UiInputNumberInteger size={3} name="prazoDias" label="Prazo em dias"/>
                        <UiInputCheckbox size={3} name="padrao" label="Padrão"/>
                    </div>

                    <fieldset>
                        <legend>Liberação</legend>
                        <div className="row">
                            <UiInputList size={12} name="dependencias" list={tipoList} idField="id" titleField="title" label="Depende da conclusão de" placeholder={false} multiple style={{ height: 'auto', minHeight: 96 }}/>
                            <div className="col-lg-12">
                                <p className="text-muted small">
                                    Marcar <strong>Padrão</strong> faz o tipo nascer em toda obra fechada, aguardando
                                    as dependências acima.
                                </p>
                            </div>
                        </div>
                    </fieldset>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
